export default "__VITE_ASSET__wv4dzbC8__"